import api from '../../utils/axios';

let cachedRawVouchers = null;
let lastFetchTime = 0;
const CACHE_TTL = 60000; // 60 seconds TTL

/**
 * Returns cached vouchers if fresh, or fetches from backend.
 * @param {boolean} forceRefresh - If true, ignores cache and fetches fresh data
 * @returns {Promise<Array>} List of agent vouchers
 */
export const getCachedVouchers = async (forceRefresh = false) => {
    const now = Date.now();
    if (!forceRefresh && cachedRawVouchers && (now - lastFetchTime < CACHE_TTL)) {
        return cachedRawVouchers;
    }

    try {
        const res = await api.get("/agent/vouchers");
        const vouchers = Array.isArray(res.data) ? res.data : (res.data?.vouchers || []);
        cachedRawVouchers = vouchers;
        lastFetchTime = Date.now();
        return vouchers;
    } catch (err) {
        // If fetch fails but we have stale cache, return it as fallback
        if (cachedRawVouchers) {
            return cachedRawVouchers;
        }
        throw err;
    }
};

/**
 * Synchronous peek into the cache.
 * Returns cached vouchers if valid, or null.
 */
export const peekCachedVouchers = () => {
    if (cachedRawVouchers && (Date.now() - lastFetchTime < CACHE_TTL)) {
        return cachedRawVouchers;
    }
    return null;
};

/**
 * Invalidate cache manually (e.g., after voucher creation or deletion)
 */
export const invalidateVouchersCache = () => {
    cachedRawVouchers = null;
    lastFetchTime = 0;
};
